import { apiRequest } from "./client";

export const shippingApi = {
  registerShipment(projectId, orderId) { return apiRequest(`/projects/${encodeURIComponent(projectId)}/orders/${encodeURIComponent(orderId)}/shipment`, { method: "POST", timeout: 180000, retryAttempts: 0 }); },
  syncShipment(projectId, orderId) { return apiRequest(`/projects/${encodeURIComponent(projectId)}/orders/${encodeURIComponent(orderId)}/shipment/sync`, { method: "POST" }); },
  linkShipment(projectId, orderId, payload) { return apiRequest(`/projects/${encodeURIComponent(projectId)}/orders/${encodeURIComponent(orderId)}/shipment/link`, { method: "POST", body: JSON.stringify(payload) }); },
  cancelShipmentRecord(projectId, orderId, payload) { return apiRequest(`/projects/${encodeURIComponent(projectId)}/orders/${encodeURIComponent(orderId)}/shipment/cancelled-remotely`, { method: "POST", body: JSON.stringify(payload) }); },
  label(projectId, orderId) { return apiRequest(`/projects/${encodeURIComponent(projectId)}/orders/${encodeURIComponent(orderId)}/shipment/label`, { responseType: "blob", timeout: 30000 }); },
  get(projectId) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping`);
  },
  lookupCustomer(projectId, payload) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping/correo-customer`, { method: "POST", body: JSON.stringify(payload) });
  },
  test(projectId, payload) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping/test`, { method: "POST", body: JSON.stringify(payload) });
  },
  save(projectId, config) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping`, {
      method: "PUT",
      body: JSON.stringify(config),
    });
  },
};
